module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "psocket"
  }, [_c('div', {
    attrs: {
      "id": "PSocket"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0140fe92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flash/PSocket.vue
// module id = 377
// module chunks = 0